import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { reduxForm, Field, isDirty, getFormValues, formValueSelector } from "redux-form";
import InputField from "../_common/InputField";
import SelectSimple from "../_common/SelectSimple"; 
import PageTitle from "../_components/utils/PageTitle";
import { Input, Pagination, Table, Alert, Button, Icon } from 'antd';
import { adminuserActions } from "../_actions";
import { store } from "../_helpers";
import CheckBoxSimple from "../_common/CheckBoxSimple";
import {TextareaSimple} from "../_common";
import axios from "axios";
import { API_URL } from "../_config";
import "react-tabs/style/react-tabs.css";
import Highlighter from 'react-highlight-words';

import {
  Row,
  Col,
  Container,
  Card,
  CardBody,
  CardHeader
} from "shards-react";

const Form = props => {
  const { handleSubmit, handleChange,  pristine, reset, submitting, currentTipo, currentEntidad } = props

  const [data, setData] = useState([]);
  const [pDisabled, setPDisabled] = useState(true);

  // Detecta si el informe seleccionado requiere datos del titular
  // (VERAZ, NOSIS, NOMINALES o INHIBICION)
  const requiereTitular = /veraz|nosis|nominal|inhibic/i.test(currentTipo || '');
  const entidad = currentEntidad || 'persona';

  useEffect(() => {

    axios({
        method: "get",
        url:
          API_URL + "api/service_informes?token=" + store.getState().authentication.user.token
      }).then(response => {
        setData(response.data.data);
        setPDisabled(false);
      });


  }, [])


  return (
        <Card>
            <CardHeader>
                Datos del Solicitante
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit}>
                <h4 style={{borderBottom: '2px solid rgb(142, 141, 141)', color: 'rgb(95, 95, 95)', textTransform: 'unset', fontWeight: '350', borderRadius: '1px'}}>Ingrese el nombre de la Concesionaria</h4>
 
                <Field
            name="sociocca"
            component={InputField}
            type="text"
            label="Razón Social"
          />

           <Field
            name="marcamodelo"
            component={InputField}
            type="text"
            label="Marca y Modelo"
          />

           <Field
            name="solicitante"
            component={InputField}
            type="text"
            label="Solicitante"
          />

           <Field
            name="email"
            component={InputField}
            type="email"
            label="Email"
          />

            <h4 style={{marginTop: '25px', marginBottom: '10px', borderBottom: '2px solid rgb(142, 141, 141)', color: 'rgb(95, 95, 95)', textTransform: 'unset', fontWeight: '350', borderRadius: '1px'}}>Seleccione el tipo de informe</h4>
            <label>Categoría</label>
            <div>
            <Field name="tipo" component='select' disabled={pDisabled} className="form-control">
                {data.map(function(item, i){
                    if(item.hidden != true) {
                        return <option value={item.elementos} key={i}>{item.elementos + ' ($ ' + item.importe + ')'}</option>
                    }
                })}
            </Field>
          </div>

          {/* Bloque condicional: aparece solo si el informe es VERAZ/NOSIS/NOMINAL/INHIBICION.
              Pide datos del titular según sea Persona Física o Empresa. */}
          {requiereTitular && (
            <div>
              <h4 style={{marginTop: '25px', marginBottom: '10px', borderBottom: '2px solid rgb(142, 141, 141)', color: 'rgb(95, 95, 95)', textTransform: 'unset', fontWeight: '350', borderRadius: '1px'}}>Datos del titular</h4>

              <label>Tipo</label>
              <div>
                <Field name="entidad" component="select" className="form-control">
                  <option value="persona">Persona Física</option>
                  <option value="empresa">Empresa</option>
                </Field>
              </div>

              {entidad === 'empresa' ? (
                <>
                  <Field
                    name="razonsocial"
                    component={InputField}
                    type="text"
                    label="Razón Social"
                  />
                  <Field
                    name="cuit"
                    component={InputField}
                    type="text"
                    label="CUIT"
                  />
                </>
              ) : (
                <>
                  <Field
                    name="nombre"
                    component={InputField}
                    type="text"
                    label="Nombre y Apellido"
                  />
                  <Field
                    name="dni"
                    component={InputField}
                    type="text"
                    label="DNI"
                  />
                </>
              )}
            </div>
          )}

            {/* Sección "Adicionales" — deshabilitada temporalmente (sin opciones activas)
            <p style={{margin: '0px', marginTop: '25px'}}>Adicionales:</p>

            <Field
            name="adicional2"
            component={'input'}
            type="checkbox"
          /><label>Informe de Infracciones</label>
          */}

           <h4 style={{marginTop: '25px', marginBottom: '10px', borderBottom: '2px solid rgb(142, 141, 141)', color: 'rgb(95, 95, 95)', textTransform: 'unset', fontWeight: '350', borderRadius: '1px'}}>Observaciones</h4>
           <Field
            name="notas"
            component={TextareaSimple}
            type="text"
            label="Notas"
          />


<button type="submit" className="btn btn-primary mt-3"  disabled={submitting}>
            Guardar
        </button>
            </form>
            </CardBody>
        </Card>
        
  )
   
}


const formSelector = formValueSelector('Form');

function mapState(state, props) {

    const { users, authentication, vehicles, adminuser } = state;

    const { user } = authentication;

    return {
      user,
      users,
      adminuser,
      currentTipo:    formSelector(state, 'tipo'),
      currentEntidad: formSelector(state, 'entidad'),
      // Valor inicial: cuando se abre el form, la sub-selección arranca en "Persona Física"
      initialValues: { entidad: 'persona' },
    };
  }
  const actionCreators = {
  
  };

const po = reduxForm({
  form: 'Form', 
  enableReinitialize: true
})(Form);

const pox = connect(
    mapState,
    actionCreators
  )(po);
  
export { pox as Form };